// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"159":"host-app","566":"bit-app"}[chunkId] || chunkId) + "." + {"159":"a3af054e","352":"5e0b6037","566":"7f6f8f5d"}[chunkId] + ".chunk.js";
};